module.exports = __webpack_public_path__ + "img/icon_benefit_05_01_w.74441b43.svg";